import React from 'react';

import * as S from './styled';

const Footer = () => (
  <S.Container>
    <S.Text>Prefeitura de Glória do Goitá © 2020 - Todos os direitos reservados</S.Text>
  </S.Container>
);

export default Footer;